/* eslint-disable ember/no-classic-components, ember/require-tagless-components */
import Component from '@ember/component';
import TransactionType from '@linc-technologies/linced-common/enums/transaction-type';

export default class TransactionComment extends Component {
  TransactionType = TransactionType;
}
